/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-service-pool-members-grid';
const prefix = `${moduleName}.${componentName}`;

export const poolMembersGridLabel = `${prefix}.poolMembersGridLabel`;
export const publicIpLabel = `${prefix}.publicIpLabel`;
export const fqdnLabel = `${prefix}.fqdnLabel`;
export const privateAddressColumnHeader = `${prefix}.privateAddressColumnHeader`;
export const addressColumnHeader = `${prefix}.addressColumnHeader`;

export const ENGLISH = {
    [poolMembersGridLabel]: 'Members ({0})',
    [publicIpLabel]: 'Public IP',
    [fqdnLabel]: 'FQDN',
    [privateAddressColumnHeader]: 'Private Address',
    [addressColumnHeader]: 'Address',
};
